import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import permissionPolicyDTO, { PermissionPolicyDTO } from '../../../../domain/permission/PermissionPolicyDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import PermissionPolicyId = com.eidu.sharedlib.entity.permission.PermissionPolicyId

export type GetPermissionPolicyParameters = { id: PermissionPolicyId }

const getPermissionPolicy = async ({ id }: GetPermissionPolicyParameters): Promise<PermissionPolicyDTO | null> => {
  return fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/policies/${id.toString()}`,
    { headers: { Accept: 'application/json' } }
  ).then(async (response) => {
    switch (response.status) {
      case 200:
        return permissionPolicyDTO((await response.json()).document)
      case 404:
        console.warn(`Got status ${response.status} from getPermissionPolicy endpoint`)
        return null
      default:
        throw Error(`Unexpected response code ${response.status} from getPermissionPolicy endpoint`)
    }
  })
}

export default getPermissionPolicy
